import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "-mt-1 flex-1" }

import BaseIcon from '@/lib/components/Icon/BaseIcon.vue';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSummaryGrid',
  props: {
  value: {
    type: Array as PropType<{ icon: string | null; value: string }[]>,
    default: () => []
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid w-full gap-x-2", `grid-cols-${__props.value.length}`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${item.value}${index}`,
        class: "flex space-x-3"
      }, [
        (item.icon)
          ? (_openBlock(), _createBlock(BaseIcon, {
              key: 0,
              name: item.icon,
              stroke: false
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_1, _toDisplayString(item.value), 1)
      ]))
    }), 128))
  ], 2))
}
}

})